import React from 'react';
import SideMenu from '../components/side-menu';
import TabPanel from '../components/tab-panel';
import CreditImageBio from '../components/credit-image-bio';
import CreditsExpander from '../components/credits-expander';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


import '../styles/credits.css'

// Function to detect mobile device
const isMobileDevice = () => {
    if (typeof navigator !== 'undefined') {
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    return false; // fallback if navigator is not available
  };

const Credits = () => {


    const mobile = isMobileDevice();

    const settings = mobile ? 
    {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        rows: 1,
        dots: true,
        // your mobile-specific settings
    } :
    {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        // your desktop-specific settings
    };
    
    return (
        <div className='page-wrapper credits'>
            <SideMenu active='credits'/>
            <div className='content'>
                <h1 className='credits-h1'>About This Exhibit</h1>
                <h2 id='credits-1'>The Project</h2>
                <p>In 2021, the <a href='https://lgbtqdigitalcollaboratory.org/about/' target='_blank'>LGBTQ Oral History Digital Collaboratory</a> — directed by Elspeth Brown — launched the <a href='https://pussypalaceproject.org/' target='_blank'><i>Pussy Palace Oral History Project</i></a> (PPOHP). The project preserves 36 interviews with patrons, organizers, and allies of Toronto’s iconic Pussy Palace bathhouse events. These interviews explore not only the 2000 police raid but also the sex and gender cultures that shaped queer life in early 21st-century Toronto.</p>
                <p>You can view the full collection of video-recorded interviews or read official transcripts on the PPOHP project website. </p>
                <div class='center-button'>
                    <a href='https://pussypalaceproject.org/oral-histories/' target='_blank' class='btn'>Explore Collection</a>
                </div>
                <p>To help connect wider audiences with this rich archive, the Collaboratory developed this interactive digital exhibit. Visitors are invited to explore the evolution of the Pussy Palace events, hear first-person accounts of the raid and its aftermath, and experience the pleasures, tensions, and provocations of the physical space as virtual patrons.</p>
                <h2 id='credits-2'>The Team</h2>
                <p>
                Meet the people behind this digital exhibit — a collaboration between two teams: 
                the <b>LGBTQ Oral History Digital Collaboratory</b>, who led the <i>Pussy Palace Oral History Project</i>, 
                and the <b>UX Design for DH Accelerator Program</b>, an initiative of the <a href='https://dhn.utoronto.ca/'>Critical Digital Humanities Initiative</a>, 
                which supported the exhibit’s design and development. Together, these teams brought together oral historians, 
                artists, designers, and developers to realize the exhibit.
                </p>
                <Slider {...settings}>

                    <div class='team-member'>
                        <small>Collaboratory</small>
                        <img alt='' src='/assets/images/team/elspeth.jpg'/>
                        <h4>Elspeth Brown</h4>
                        <h5>Lead Historian</h5>
                        <CreditsExpander content={
                        <>
                            <p>
                                Elspeth is Director of the LGBTQ Oral History Digital Collaboratory and Principal Investigator for the <i>Pussy Palace Oral History Project</i>. As Lead Historian for the digital exhibit, Elspeth co-wrote the historical narrative and consulted with the development team to support the site’s design.
                            </p>
                            <p>
                            Elspeth is also Professor of History at the University of Toronto where her research focuses on queer and trans history, oral history, queer archives, public history, photography, and the history of U.S. capitalism. She is the author of <i>Work! A Queer History of Modeling</i> (Duke University Press, 2019) and numerous articles, including “Trans Oral History as Trans Care” (<i>Oral History Review</i>, 2022) and “Archival Activism, Symbolic Annihilation, and the LGBTQ+ Community Archive” (<i>Archivaria</i>, 2020).
                            </p>
                            <p>
                            From 2020 to 2024, she served as Associate Vice-President, Research (Strategic Initiatives) at the University of Toronto Mississauga and as Director of the <a href='https://dhn.utoronto.ca/'>Critical Digital Humanities Initiative</a>.
                            </p>
                            <p>
                            To learn more about Elspeth's work, visit <a href='https://www.elspethbrown.org/' target="_blank">elspethbrown.org</a> or contact Elspeth at <a href="mailto:elspeth.brown@utoronto.ca">elspeth.brown@utoronto.ca</a>
                            </p>
                        </>
                        }/>
                    </div>

                    <div class='team-member'>
                        <small>Collaboratory</small>
                        <img alt='' src='/assets/images/team/alisha.jpg'/>
                        <h4>Alisha Stranges</h4>
                        <h5>Project Manager & Creative Lead</h5>
                        <CreditsExpander content={
                        <>
                            <p>  
                            Alisha joined the Collaboratory in 2021 as Project Manager and Co-Oral Historian for the <i>Pussy Palace Oral History Project</i>, where she conducted 36 interviews and led a five-member team in the preservation and creative activation of these histories. As the Collaboratory’s Research Manager, she continues to support the planning and execution of concurrent projects.
                            </p>
                            <p> 
                            For the digital exhibit, Alisha co-wrote the historical narrative and served as Creative Lead, designing the overall structure and five of the six sections. She created graphic elements, integrated digital illustrations with interview audio to produce video assets, and worked closely with the development team across multiple iterations to refine the final user experience.
                            </p>
                            <p>
                            As a public humanities scholar and multi-modal artist, Alisha’s work bridges queer oral history, performance, and digital research creation. She holds an M.A. in Women & Gender Studies from the University of Toronto, with a collaborative specialization in Sexual Diversity Studies, and a Diploma in Theatre Performance from Humber College.
                            </p>
                            <p>
                                Contact Alisha at <a href="mailto:alisha.stranges@mail.utoronto.ca">alisha.stranges@mail.utoronto.ca</a>
                            </p>
                        </>
                        }/>
                    </div>

                    <div class='team-member'>
                        <small>Accelerator</small>
                        <img alt='' src='/assets/images/team/peter.jpg'/>
                        <h4>Peter Luo</h4>
                        <h5>UX Designer</h5>
                        <CreditsExpander content={
                        <>
                        <p>Peter is a User Experience (UX) professional with a practical approach to design thinking and a passion to improve user experiences. </p>
                        <p>As UX Designer for the digital exhibit, he led the initial design stage, establishing the foundation for its final iteration. Over six weeks, Peter collaborated with the research team to prototype and refine interactive designs, conducted usability testing, and presented solutions to project narrators to ensure the exhibit was engaging, intuitive, and respectful of their stories.</p>
                        </>
                        }/>
                    </div>
                    <div class='team-member'>
                        <small>Collaboratory</small>    
                        <img alt='' src='/assets/images/team/ayo.jpg'/>
                        <h4>Ayo Tsalithaba</h4>
                        <h5>Visual Aritst</h5>
                        <CreditsExpander content={
                        <>
                        <p>Ayo is a visual artist, originally from Ghana and Lesotho, whose practice spans film, photography, and illustration. </p>
                        <p>As Creative Producer for the <i>Pussy Palace Oral History Project</i>, they developed the project’s visual identity, edited interview access copies, and produced a series of animated shorts combining digital illustration with interview soundbites and original soundscapes. For the digital exhibit, they created narrator sketches and hero images featured throughout, as well as illustrated room backgrounds for the interactive “Explore the Palace” section. </p>
                        <p>To learn more about Ayo’s work, visit <a href='https://www.ayotsalithaba.com/' target="_blank">ayotsalithaba.com</a>.</p>
                        </>
                        }/>
                    </div>
                    <div class='team-member'>
                        <small>Accelerator</small>
                        <img alt='' src='/assets/images/team/jesse.jpg'/>
                        <h4>Jesse Sinfield</h4>
                        <h5>Developer (Final Build)</h5>
                        <CreditsExpander content={
                        <>
                        <p>Jesse is a web developer with over a decade of experience transforming thoughtful web designs into rich, interactive, and accessible digital interfaces. </p>
                        <p>As Developer for the exhibit’s final build, Jesse enhanced interactivity, streamlined navigation, optimized mobile performance, and improved accessibility — ensuring the site is as dynamic and engaging as the histories it showcases.</p>
                        <p>From large-scale WordPress platforms to dynamic React apps, Jesse thrives on turning complex content into user-friendly, high-performance websites. </p>
                        <p>Drop a line to <a href='mailto:jessesinfield@gmail.com' target="_blank">jessesinfield@gmail.com</a> if you’d like to get in touch.</p>
                        </>
                        }/>
                    </div>

                    <div class='team-member'>
                        <small>Accelerator</small>
                        <img alt='' src='/assets/images/team/matt.jpg'/>
                        <h4>Matt Lefaive</h4>
                        <h5>Developer (Prototype)</h5>
                        <CreditsExpander content={
                        <>
                        <p>Matt is a web developer and digital humanist who served as the resident Digital Humanities Developer for the <a href='https://dhn.utoronto.ca/'>Critical Digital Humanities Initiative</a> from 2022–25.</p>
                        <p>As Developer for the exhibit prototype, Matt established the initial React architecture that guided later iterations and supported the Collaboratory with back-end development of the <a href='https://pussypalaceproject.org/'>PPOHP project site</a>. </p>
                        <p>He holds an HBSc in Computer Science and Linguistics from the University of Toronto Scarborough and is particularly interested in open access research and web tools for language preservation.</p>
                        </>
                        }/>
                    </div>

                    <div class='team-member'>
                        <small>Accelerator</small>
                        <img alt='' src='/assets/images/team/danielle.jpg'/>
                        <h4>Danielle Taschereau Mamers</h4>
                        <h5>Program Co-Ordinator</h5>
                        <CreditsExpander content={
                        <>
                        <p>Danielle is a scholar and cultural worker who served as Managing Director of the <a href='https://dhn.utoronto.ca/'>Critical Digital Humanities Initiative</a> (CDHI) from 2021–25. </p>

                        <p>In 2022, she launched CDHI’s <a href='https://dhn.utoronto.ca/accelerator/'>UX Design for DH Accelerator Program</a>, which supported the exhibit’s design and development. As Program Coordinator, Danielle facilitated collaboration between the Accelerator team and the Collaboratory and was genuinely thrilled to watch the project move from idea to design to final product.</p>

                        <p>To learn more about Danielle’s work, visit: <a href='https://www.dtmstudio.ca/'>dtmstudio.ca</a>.</p>
                        </>
                        }/>
                    </div>

                    <div class='team-member'>
                        <small>Collaboratory</small>
                        <img alt='' src='/assets/images/team/elio.jpg'/>
                        <h4>Elio Colavito</h4>
                        <h5>Co-Oral Historian</h5>
                        <CreditsExpander content={
                        <>
                        <p>Elio is a PhD candidate in History at the University of Toronto, specializing in Sexual Diversity Studies where his research focuses on transmasculine histories of care, mutual aid, and community formation in 20th-century Canada and the U.S.</p>
                        <p>As Co-Oral Historian with the <i>Pussy Palace Oral History Project</i>, he co-conducted interviews, assisted with digital archiving, oversaw the collection of donated ephemera, generated interview summaries and transcripts, and collaborated on digital research creation projects. </p>
                        <p>To learn more about Elio’s work, visit <a href='https://www.eliocolavito.org/'>eliocolavito.org</a>.</p>
                        </>
                        }/>
                    </div>
                    
                    <div class='team-member'>
                        <small>Collaboratory</small>
                        <img alt='' src='/assets/images/team/emily.jpg'/>
                        <h4>Emily Mastragostino</h4>
                        <h5>Interview Coder</h5>
                        <CreditsExpander content={
                        <>
                        <p>Emily is a PhD student in Counselling and Clinical Psychology at the Ontario Institute for Studies in Education, University of Toronto, where her research uses a positive psychology lens to study how marginalized communities cultivate wellbeing in the face of systemic barriers.</p>
                        <p>As Interview Coder for the <i>Pussy Palace Oral History Project</i>, Emily synchronized transcript coding with interview video recordings in NVivo, helping the team identify and organize themes emerging in the oral histories of Pussy Palace organizers, patrons, and allies.</p>
                        </>
                        }/>
                    </div>
                    
                    
                    
                </Slider>

                <h2 id='credits-3'>The Narrators</h2>
                <p>This exhibit would not be possible without the generosity, vulnerability, and insight of the narrators who shared their stories. Here is a list of those who are featured throughout the site.</p>
                <h4 class='centered'>Organizers & Volunteers</h4>
                <ul>

                    <li><span>Lukas Blakk</span><span>Security Volunteer</span></li>		
                    <li><span>Chloë Brushwood Rose</span><span>Polaroid Photographer</span></li>	
                    <li><span>Noelle Campbell-Smith</span><span>Bartender</span></li>
                    <li><span>Karen B. K. Chan</span><span>TWBC Member</span></li>
                    <li><span>Chanelle Gallant</span><span>TWBC Member</span></li>
                    <li><span>Diane Hamilton</span><span>TWBC Member</span></li>
                    <li><span>JP Hornick</span><span>Security Volunteer</span></li>		
                    <li><span>Carlyle Jansen</span><span>TWBC Co-Founder</span></li>
                    <li><span>Tera Mallette</span><span>Security Volunteer</span></li>	
                    <li><span>Leanne Powers</span><span>Temple Priestess</span></li>	
                    <li><span>Renee Racine</span><span>Security Volunteer</span></li>	
                    <li><span>Terri Roberton</span><span>Body Painter & Patron</span></li>	
                    <li><span>Janet Rowe</span><span>TWBC Co-Founder</span></li>
                    <li><span>Deb Singh</span><span>TWBC Member</span></li>
                    
                </ul>
                <h4 class='centered'>Patrons & Community Allies</h4>
                <ul>
                    <li><span>Ange Beever</span><span>Patron</span></li>
                    <li><span>Olivia Chow</span><span>Community Ally</span></li>	


                    <li><span>Brenda Cossman</span><span>Patron & Legal Consultant</span></li>	
                    <li><span>Stephanie Dutrizac</span><span>Patron</span></li>	
                    <li><span>T’Hayla Ferguson</span><span>Patron</span></li>	
                    <li><span>Bob Gallagher</span><span>Community Ally</span></li>	
                    <li><span>Paul Gallant</span><span>Journalist</span></li>	
                    <li><span>Nia Herlihy</span><span>Patron</span></li> 


                    <li><span>Nancy Irwin</span><span>Patron</span></li>	
                    <li><span>Pam Johnson</span><span>Activist & Post-Raid Patron</span></li>

                    <li><span>Lyla Miklos</span><span>Patron</span></li>	
                    <li><span>Anthony Mohamed</span><span>Community Ally</span></li>	

                    <li><span>Sabrina Olender</span><span>Patron</span></li>
                    <li><span>Lynda J. Perry</span><span>Patron</span></li> 

                    <li><span>Andrea Ridgley</span><span>Patron</span></li>	
                    <li><span>Trish Salah</span><span>Patron</span></li>	

                    <li><span>Hanlon Uafás-Álainn</span><span>Patron</span></li>	
                    <li><span>Mariana Valverde</span><span>Community Ally</span></li>	
                    <li><span>Josey Vogels</span><span>Journalist</span></li>	

                    <li><span>Anna Willats</span><span>Patron & Community Ally</span></li>	
                    <li><span>Robin Woodward</span><span>Patron</span></li>	

                    
                </ul>
                <h2 id='credits-4'>With Special Thanks</h2>
                <p>We are deeply grateful to <a href='https://arquives.ca/' target='_blank'>The ArQuives: Canada’s LGBTQ2+ Archives</a> for their partnership during the <i>Pussy Palace Oral History Project</i>. The ArQuives supported the collection and long-term preservation of this oral history archive, with Executive Director <b>Raegan Swanson</b> providing leadership, Archivist <b>Lucie Handley-Girard</b> (2017–2024) overseeing the stewardship of the materials, and Communications Assistant <b>Jordan Saroya</b> assisting with administration during the collection and archiving phases.</p>
                <p>We also extend heartfelt thanks to <b>Steff J. Mendolia</b>, who supported narrator <b>Lynda J. Perry</b> with technical and administrative tasks during the interview process, and to <b>Geena R.</b>, co-owner of <a href='https://oasisaqualounge.com/' target='_blank'>Oasis Aqualounge</a>, for generously granting the Collaboratory team access to the building — formerly Club Toronto — to support the exhibit’s design research.</p>
                <h2 id='credits-5'>Resources & Research Creation</h2>
                <p>This exhibit draws on a rich set of oral history materials, archival resources, and creative projects developed by the Collaboratory. For more on our research process and creative outputs, visit the PPOHP project website.</p>
                <div class='center-button'>
                    <a href='https://pussypalaceproject.org/' target='_blank' class='btn'>Visit Project Site</a>
                </div>
            </div>
        </div>
    )
}

export default Credits;